<template>
    <div id="load-box">
        <div>
            <svg viewBox="0 0 1 1" xmlns="http://www.w3.org/2000/svg" :width="size" :height="size">
                <path d="M 0.0 0.5
                     A 0.5 0.5 0 1 1 0.5 1.0
                     A 0.05 0.05 0 0 1 0.5 0.9
                     A 0.4 0.4 0 1 0 0.1 0.5
                     A 0.05 0.05 0 0 1 0.0 0.5" stroke-width="0" :fill="color">
                     <animateTransform attributeName="transform"
                              attributeType="XML"
                              type="rotate"
                              from="0 0.5 0.5"
                              to="360 0.5 0.5"
                              dur="1.5s"
                              repeatCount="indefinite"/>
                 </path>
            </svg>
        </div>
        <label>加载中...</label>
    </div>
</template>

<script type="text/javascript">
const myStore = require('../my-store.js');
const allConfigs = require('../app-config.js');
export default {
    name: 'GenchLoadingView',
    props: {
        color: {
            type: String,
            default: '#0BD'
        },
        size: {
            type: String,
            default: '60px'
        }
    },
    data: function() {
        return {
            obj: null,
            appInfo: '',
        };
    },

    mounted: function() {
        // console.log(this.$route.query);
        // console.log(this.$route.params);
        // 来自第三方学校登录
        // 上海建桥
        if (this.$route.query.code) {
            this.toProduct(this.$route.query.code);
        }

        // 从portal跳转来的
        if (this.$route.query.product && this.$route.query.product === 'PORTAL') {
            this.$axios.request({
                method: 'GET',
                url: `/schools/${this.$route.query.schoolOid}/sso-config?product=PORTAL`
            }).then(resp => {
                const data = resp.data;
                // console.log(data);
                if (! data.status) {
                    this.showFail(resp, 'PORTAL');
                    return;
                }

                if (data.ssoConfig.authType === 'THIRD_SSO') {
                    // console.log(this.$route);
                    let url = data.ssoConfig.goToUrl + `product: ${data.ssoConfig.product}`;
                    // console.log(url);
                    window.location.href = url;
                }
            }).catch(err => {
                this.showError(err);
            });
        }
    },

    methods: {
        toProduct: function(code) {
            let accessId = this.$route.params.school;
            // let code = this.$route.query.code;
            let obj = {};
            if (this.$route.query.state) {
                const str = this.$route.query.state;
                const regex = /(\w+)\s*:\s*([^\s,]+)/g;//匹配一个键值对的字符串。匹配一个键（包含一个或多个单词字符 (\w+) ），后面可以有一个冒号和可选的空格，接下来是一个值（包含一个或多个不是空格或逗号字符的字符 [^\s,]+）。最后的 'g' 标志表示它会匹配输入字符串中的所有匹配项
    
                //利用正则从字符串中逐一提取所有键值对
                let match;
                while ((match = regex.exec(str))) {
                const [_, key, value] = match;
                    obj[key] = value;
                }

                this.obj = obj;
                // if (obj.product === 'MOSOTEACH') {
                    myStore.saveToken(obj.mttoken);
                    this.validate(accessId, code, obj);
                // } else {
                //     // console.log('跳转portal');
                //     this.createPortalToken(accessId, code);
                // }
            } else {
                this.$alert('参数错误', '错误', {
                    confirmButtonText: '确定',
                    type: 'error',
                    callback: action => {
                        if (process.env.NODE_ENV === 'development') {
                            let url = process.env.VUE_APP_TEACH_WEB_URL;
                            window.location.href = url;
                        }

                        if (process.env.NODE_ENV === 'production') {
                            let url = process.env.VUE_APP_TEACH_WEB_URL;
                            window.location.href = url;
                        }
                    }
                });
            }
            // else {
            //     // console.log('跳转portal');
            //     this.createPortalToken(accessId, code);
            // }
    
        },

        validate: function(accessId, code, state) {
            this.$axios.request({
                method: 'POST',
                url: '/schools/login',
                data: {
                    accessId: accessId,
                    code: code,
                    product: state.product,
                }
            }).then(resp => {
                const data = resp.data;
                // console.log(data);
                if (data.status) {
                    if (data.token) {
                        myStore.saveToken(data.token);
                    }
                    
                    if (data.nextStep === 'RETURN_TO_APP') {
                            this.returnToApp();
                    } else if (data.nextStep === 'RETURN_TO_PORTAL') {
                        this.returnPortal(accessId);
                    } else {
                        this.$router.push({
                            path: '/',
                            query: {
                                currentScene: data.nextStep,
                                schoolUser: data.schoolUser,
                                accountOid: data.accountOid,
                                acsId: accessId,
                                state: state,
                                schoolToken: data.token,
                                authType: 'THIRD_SSO',
                            }
                        });
                    }

                }

                if (! data.status) {
                    this.showFail(resp, 'MOSOTEACH');
                }
            }).catch(err => {
                this.showError(err);
            });
        },

        // createPortalToken: function(accessId, code) {
            // this.$axios.request({
            //     method: 'POST',
            //     url: `/schools/create-portal-token`,
            //     data: {
            //         accessId: accessId,
            //         code: code,
            //     }
            // }).then(resp => {
            //     const data = resp.data;
            //     // console.log(data);
            //     if (! data.status) {
            //         this.showFail(resp, 'PORTAL');
            //         return;
            //     }
                
            //     if (process.env.NODE_ENV === 'development') {
            //         let url = `https://${data.site}.mbook.cc/login-by-school-sso-token?token=${data.token}`;
            //         window.location.href = url;
            //     }

            //     if (process.env.NODE_ENV === 'production') {
            //         let url = `https://${data.site}.mosoteach.cn/login-by-school-sso-token?token=${data.token}`;
            //         window.location.href = url;
            //     }

            // }).catch(err => {
            //     this.showError(err);
            // });
        // },

        showError: function(msg) {
            this.$alert(msg, {
                title: '错误',
                type: 'error',
            }).then(() => {
                if (this.loading) {
                    this.loading = false;
                }
            });
        },

        showFail: function(resp, type) {
            const data = resp.data;
            const code = data.errorCode;
            let msg = null;
            if (code === 'VALIDATION_FAILED') {
                const errors = data.errors;
                if (errors) {
                    msg = Object.keys(errors).map(k => errors[k]).join('；');
                } else {
                    msg = data.errorMessage || '验证失败';
                }
            } else {
                msg = resp.data.errorMessage;
            }
            
            if (type === "PORTAL") {
                this.$alert(msg, '错误', {
                    confirmButtonText: '确定',
                    type: 'error',
                    callback: action => {
                        this.toPortal();
                    }
                });
            }

            if (type === "MOSOTEACH") {
                this.$alert(msg, '错误', {
                    confirmButtonText: '确定',
                    type: 'error',
                    callback: action => {
                        this.toMosoteach();
                    }
                });
            }
        },

        toPortal: function() {
            let accessId = window.location.pathname.split('/')[2];
            this.$axios.request({
                method: 'GET',
                url: `schools/${accessId}/school-simple`,
            }).then(resp => {
                const data = resp.data;
                // console.log(data);
                if (process.env.NODE_ENV === 'development') {
                    let url = `https://${data.school.site}.mbook.cc`;
                    window.location.href = url;
                }

                if (process.env.NODE_ENV === 'production') {
                    let url = `https://${data.school.site}.mosoteach.cn`;
                    window.location.href = url;
                }

            }).catch(err => {
                this.showError(err);
            });
        },

        toMosoteach: function() {
            let url = allConfigs[process.env.NODE_ENV].apps[this.obj.appId].returnTo;
            window.location.href = url;
        },

        returnToApp: function() {
            const envConfig = allConfigs[process.env.NODE_ENV];
            this.appInfo = envConfig.apps[this.obj.appId];
            this.$axios.request({
                method: 'POST',
                url: '/users/create-coreapi-token',
                data: {}
            }).then(resp => {
                const data = resp.data;
                // console.log(data);
                if (! data.status) {
                    window.console && console.error('获取coreapi-token失败', data);
                    this.showFail(resp, 'MOSOTEACH');
                    return;
                }
                myStore.clear();
                const coreapiToken = data.coreapiToken;
                const url = `${this.appInfo.returnTo}?appId=${this.obj.appId ? this.obj.appId : 'MTWEB'}&token=${coreapiToken}${this.obj.returnParam ? `&returnParam=${this.obj.returnParam}` : '&returnParam=home'}`;
                window.console && console.log('返回跳转链接：', url);
                window.location.href = url;
            }).catch(err => {
                window.console && console.error('获取coreapi-token异常', err);
                this.showError(err);
            })
        },

        returnPortal: function(accessId) {
            this.$axios.request({
                method: 'POST',
                url: `/schools/create-portal-token`,
                data: {
                    accessId: accessId,
                }
            }).then(resp => {
                const data = resp.data;
                // console.log(data);
                if (! data.status) {
                    this.showFail(resp, 'PORTAL');
                    return;
                }
                
                if (process.env.NODE_ENV === 'development') {
                    let url = `https://${data.site}.mbook.cc/login-by-school-sso-token?token=${data.token}`;
                    window.location.href = url;
                }

                if (process.env.NODE_ENV === 'production') {
                    let url = `https://${data.site}.mosoteach.cn/login-by-school-sso-token?token=${data.token}`;
                    window.location.href = url;
                }

            }).catch(err => {
                this.showError(err);
            });
        },

    }
};
</script>
<style scoped>
#load-box {
    text-align: center;
    padding-top: 40px;
}
</style>

